import { z } from 'zod';

export const cutMaterialFormSchema = z.object({
  material_name: z.string()
    .min(1, 'El nombre del material es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  material_type: z.string()
    .max(100, 'El tipo de material debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  dimensions: z.string()
    .max(255, 'Las dimensiones deben tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  thickness: z.string()
    .max(50, 'El grosor debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  quantity: z.number()
    .min(0.001, 'La cantidad debe ser mayor a 0')
    .default(1),
  unit: z.string()
    .max(50, 'La unidad debe tener máximo 50 caracteres')
    .default('units'),
  batch_number: z.string()
    .max(100, 'El número de lote debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  cut_date: z.string()
    .optional()
    .or(z.literal('')),
  location: z.string()
    .max(255, 'La ubicación debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  assigned_to_work_order_id: z.string()
    .uuid('Debe ser un UUID válido')
    .optional()
    .or(z.literal('')),
  notes: z.string()
    .max(2000, 'Las notas deben tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  status: z.enum(['available', 'reserved', 'used'])
    .default('available'),
  is_active: z.boolean().default(true),
});

export type CutMaterialFormData = z.infer<typeof cutMaterialFormSchema>;
